import React from 'react';

const LeftArrowIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.97461 12.9746L6.52461 9.52461C6.44961 9.44961 6.39648 9.36836 6.36523 9.28086C6.33398 9.19336 6.31836 9.09961 6.31836 8.99961C6.31836 8.89961 6.33398 8.80586 6.36523 8.71836C6.39648 8.63086 6.44961 8.54961 6.52461 8.47461L9.97461 5.02461C10.1121 4.88711 10.2871 4.81836 10.4996 4.81836C10.7121 4.81836 10.8871 4.88711 11.0246 5.02461C11.1621 5.16211 11.2309 5.33711 11.2309 5.54961C11.2309 5.76211 11.1621 5.93711 11.0246 6.07461L8.09961 8.99961L11.0246 11.9246C11.1621 12.0621 11.2309 12.2371 11.2309 12.4496C11.2309 12.6621 11.1621 12.8371 11.0246 12.9746C10.8871 13.1121 10.7121 13.1809 10.4996 13.1809C10.2871 13.1809 10.1121 13.1121 9.97461 12.9746Z"
        fill="#84818A"
      />
    </svg>
  );
};

export default LeftArrowIcon;
